import React from 'react';
import { setCleanInputError, setCleanTextAreaError } from '../../../../../../../utils/utils';
import { WarehouseQuoteShowRateDataForm } from '../../../../../../../app/models/WareHouseQuoteRates';

interface WarehouseQuoteRateShowFormProps {
  rateForm: WarehouseQuoteShowRateDataForm;
}

const WarehouseQuoteRateShowForm = ({ rateForm }: WarehouseQuoteRateShowFormProps) => {
  return (
    <>
      {/* Almacén */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Almacén</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={rateForm.depot}
            disabled
            onFocus={setCleanInputError}
          />
        </div>
      </div>

      {/* Producto */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Producto</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={rateForm.product ?? ''}
            disabled
            onFocus={setCleanInputError}
          />
        </div>
      </div>

      {/* Tarifa por ingreso (fijo) */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por ingreso (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                className="form-control"
                value={rateForm.container_entry_fee ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.container_entry_fee_currency ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.container_entry_fee_unit ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por día de almacenaje */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por día almacenaje</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                className="form-control"
                value={rateForm.daily_storage_fee ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.daily_storage_fee_currency ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.daily_storage_fee_unit ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por salida (fijo) */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por salida (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                className="form-control"
                value={rateForm.container_exit_fee ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.container_exit_fee_currency ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control"
                value={rateForm.container_exit_fee_unit ?? ''}
                disabled
                onFocus={setCleanInputError}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Comentarios adicionales */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Comentario adicional</label>
        <div className="col-md-9">
          <textarea
            className="form-control"
            value={rateForm.additional_comments ?? ''}
            disabled
            rows={3}
            onFocus={setCleanTextAreaError}
          />
        </div>
      </div>
    </>
  );
};

export default WarehouseQuoteRateShowForm;
